import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";

export const NumberField = ({ id, label, value, onChange, suffix, min = 0, step = 1, hint, testid }) => (
  <div className="flex flex-col gap-1.5">
    <Label htmlFor={id} className="text-xs font-semibold uppercase tracking-wider text-slate-500">
      {label}
    </Label>
    <div className="relative">
      <Input
        id={id}
        type="number"
        inputMode="decimal"
        min={min}
        step={step}
        value={value}
        onChange={(e) => onChange(e.target.value === "" ? "" : Math.max(min, +e.target.value))}
        className="h-11 rounded-sm border-slate-300 bg-white pr-16 font-mono-plex text-base text-slate-900 focus-visible:ring-2 focus-visible:ring-blue-600 focus-visible:ring-offset-0"
        data-testid={testid}
      />
      {suffix && (
        <span className="pointer-events-none absolute right-3 top-1/2 -translate-y-1/2 text-xs font-semibold uppercase tracking-wider text-slate-400">
          {suffix}
        </span>
      )}
    </div>
    {hint && <span className="text-xs text-slate-400">{hint}</span>}
  </div>
);
